export const MODAL_TYPES = {
  ADD_FOLDER: "add-folder",
  DELETE_FOLDER: "delete-folder",
  CHOOSE_TARGET_COMPANY: "choose-target-company",
  CHOOSE_TARGET_FOLDER: "choose-target-folder",
};
